import {Component, DestroyRef, EventEmitter, inject, OnInit, Output} from "@angular/core";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: "app-state-redistribution-switch",
  templateUrl: "./state-redistribution-switch.component.html",
  styleUrls: ["./state-redistribution-switch.component.scss"],
  standalone: true
})
export class StateRedistributionSwitchComponent implements OnInit {
  router = inject(Router)
  destroyRef = inject(DestroyRef)
  activatedRoute = inject(ActivatedRoute)
  
  ngOnInit(): void {
    this.router.events
        .pipe(
            takeUntilDestroyed(this.destroyRef),
        )
        .subscribe((e) => {
          if (this.router.url === '/redistributions/offers') {
            this.activeOption = 1;
          }
          if (this.router.url === '/redistributions/requests') {
            this.activeOption = 2;
          }
        })
  }
  
  activeOption: 1 | 2 = 1;

  toggleSwitch(): void {
    this.activeOption = this.activeOption === 1 ? 2 : 1;
    let url = this.activeOption === 1 ? '/redistributions/offers' : '/redistributions/requests';
    this.router.navigate([url]);
  }
}
